
/* ═══════════════════════════════════════════
   GLASHES CART DRAWER — JavaScript
   v14 — Mengenrabatt via line_level_discount_allocations (fix field name) + stackbar mit Codes
   ═══════════════════════════════════════════ */
(function(){
  'use strict';
  var initialCurrency = document.currentScript.dataset.currency;

  /* ── Config ── */
  var FREE_SHIP_THRESHOLD = 4000;          /* 40,00 € in cents */
  var FREE_GIFT_THRESHOLD = 6000;          /* 50,00 € in cents */
  /* Gratisartikel-Vergabe AUS. Zum Wiedereinschalten: Variant-ID(en) hier eintragen,
     z.B. var GIFT_VARIANTS = [12345678901234]; Bei leerem Array wird nichts hinzugefuegt,
     kein Banner und kein Fortschrittsbalken angezeigt. */
  var GIFT_VARIANTS = [53831680721232];
  /* ── Volume Discount (Shopify Function = checkout-only, mirror in drawer) ── */
  var VOLUME_TIERS = [{minQty: 3, pct: 8}, {minQty: 2, pct: 5}];

  function getVolumePct(item){
    if (!item || !item.properties || !item.properties._gl_volume) return 0;
    for (var i = 0; i < VOLUME_TIERS.length; i++){
      if (item.quantity >= VOLUME_TIERS[i].minQty) return VOLUME_TIERS[i].pct;
    }
    return 0;
  }

  function getVolumeDiscount(item){
    var pct = getVolumePct(item);
    return pct > 0 ? Math.round(item.final_line_price * pct / 100) : 0;
  }


  /* ── State ── */
  var cart = null;
  var isOpen = false;
  var isUpdating = false;
  var scriptAction = false;
  var isReconciling = false;
  var appliedCode = '';
  var giftBlocked = false;      /* true = BXGY didn't make it free, don't retry */
  var lastNonGiftCount = -1;    /* reset giftBlocked when cart items change */
  var pendingFetch = null;      /* v9: debounce fetchCart — one in-flight at a time */
  var refreshTimer = null;      /* v9: debounce refresh from interceptor */

  /* ── DOM refs ── */
  var overlay  = document.getElementById('glCartOverlay');
  var drawer   = document.getElementById('glCartDrawer');
  var body     = document.getElementById('glCartBody');
  var content  = document.getElementById('glCartContent');
  var foot     = document.getElementById('glCartFoot');
  var countEl  = document.getElementById('glCartCount');
  var totalsEl = document.getElementById('glTotals');
  var discInput = document.getElementById('glDiscountInput');
  var discBtn   = document.getElementById('glDiscountBtn');
  var discMsg   = document.getElementById('glDiscountMsg');
  var discForm  = document.getElementById('glDiscountForm');
  var appliedEl = document.getElementById('glAppliedCode');
  var noteToggle = document.getElementById('glNoteToggle');
  var noteBox    = document.getElementById('glNoteBox');
  var noteText   = document.getElementById('glNoteText');
  var noteSaved  = document.getElementById('glNoteSaved');

  /* ── Helpers ── */
  function fmt(cents){
    var currency = cart && cart.currency ? cart.currency : initialCurrency;
    return new Intl.NumberFormat(currency === 'CHF' ? 'de-CH' : 'de-DE', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
  }

  function isGift(item){
    if (!item) return false;
    if (Number(item.variant_id) === 53831680721232) return true;
    /* Only items added by cart drawer with _gl_free_gift property count as gifts.
       Customers who manually add the same product get it as a normal paid item. */
    if (item.properties && item.properties._gl_free_gift) return true;
    return false;
  }

  /* v13: final_line_price enthaelt NUR line-level Rabatte. Ein Bestellrabatt-Code
     landet in cart_level_discount_applications und senkt final_line_price nicht.
     Ohne den Abzug unten bleibt das Goodie liegen, obwohl der Warenkorb durch
     den Rabatt unter 70 EUR gefallen ist. */
  function subtotalWithoutGifts(c){
    var s = 0;
    for (var i = 0; i < c.items.length; i++){
      if (!isGift(c.items[i])) s += c.items[i].final_line_price;
    }
    var cartLevel = 0;
    var apps = c.cart_level_discount_applications || [];
    for (var d = 0; d < apps.length; d++){
      if (apps[d].total_allocated_amount){
        cartLevel += apps[d].total_allocated_amount;
      }
    }
    s = s - cartLevel;
    return s > 0 ? s : 0;
  }

  function itemCount(c){
    var n = 0;
    for (var i = 0; i < c.items.length; i++) n += c.items[i].quantity;
    return n;
  }

  function escHtml(s){
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ── Cart API ── */
  /* v9: debounce — if a fetchCart is already in-flight, return the same promise */
  function fetchCart(force){
    if (!force && pendingFetch) return pendingFetch;
    pendingFetch = fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .finally(function(){ pendingFetch = null; });
    return pendingFetch;
  }

  function changeItem(key, qty){
    isUpdating = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(function(r){ return r.json(); })
      .then(function(c){ cart = c; return c; })
      .finally(function(){ isUpdating = false; });
  }

  function addItem(variantId, qty, props){
    isUpdating = true;
    scriptAction = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items:[{id: variantId, quantity: qty || 1, properties: props || {}}]})
    }).then(function(r){ return r.json(); })
      .finally(function(){ isUpdating = false; });
  }

  /* ── Discount code (AJAX, no reload!) ── */
  function applyDiscount(code){
    if (!code) return Promise.resolve(false);
    return doApplyDiscount(code);
  }

  function updateDiscountCode(code){
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({discount:code})
    }).then(function(response){
      if(!response.ok) throw new Error('Discount update failed');
      return response.json();
    });
  }
  function doApplyDiscount(code){
    discBtn.disabled = true;
    discBtn.textContent = '...';

    /* Step 1: Clear any existing discount codes first (prevents stacking) */
    return updateDiscountCode('')
      .then(function(){
        return new Promise(function(ok){ setTimeout(ok, 300); });
      })
      .then(function(){
        /* Step 2: Apply the new code */
        return updateDiscountCode(code);
      })
      .then(function(){
        /* Step 3: Wait for Shopify to process, then re-fetch cart */
        return new Promise(function(ok){ setTimeout(ok, 600); });
      })
      .then(fetchCart)
      .then(function(c){
        cart = c;
        discBtn.disabled = false;
        discBtn.textContent = 'Anwenden';

        /* Check cart.discount_codes array for our code */
        var codeEntry = null;
        if (c.discount_codes) {
          for (var i = 0; i < c.discount_codes.length; i++) {
            if (c.discount_codes[i].code.toLowerCase() === code.toLowerCase()) {
              codeEntry = c.discount_codes[i];
              break;
            }
          }
        }

        /* Check if discount is reflected in cart_level or item-level */
        var hasCodeDiscount = false;
        if (c.cart_level_discount_applications) {
          for (var i = 0; i < c.cart_level_discount_applications.length; i++) {
            if (c.cart_level_discount_applications[i].type === 'discount_code') {
              hasCodeDiscount = true;
              break;
            }
          }
        }
        if (!hasCodeDiscount) {
          for (var j = 0; j < c.items.length; j++) {
            var allocs = c.items[j].line_level_discount_allocations || [];
            for (var k = 0; k < allocs.length; k++) {
              if (allocs[k].discount_application && allocs[k].discount_application.type === 'discount_code') {
                hasCodeDiscount = true;
                break;
              }
            }
            if (hasCodeDiscount) break;
          }
        }

        if (codeEntry && codeEntry.applicable) {
          appliedCode = code;
          showDiscountMsg('Code "' + code + '" angewendet! ✓', true);
          /* v10: reconcile gift after discount — subtotal may have dropped below 70€ */
          return reconcileGift(c).then(function(rc){ cart = rc; render(); return true; });
        } else if (codeEntry && !codeEntry.applicable) {
          showDiscountMsg('Code nicht anwendbar auf diesen Warenkorb', false);
          updateDiscountCode('');
          return false;
        } else if (hasCodeDiscount) {
          appliedCode = code;
          showDiscountMsg('Code "' + code + '" angewendet! ✓', true);
          /* v10: reconcile gift after discount */
          return reconcileGift(c).then(function(rc){ cart = rc; render(); return true; });
        } else {
          showDiscountMsg('Ungültiger oder abgelaufener Code', false);
          updateDiscountCode('');
          return false;
        }
      })
      .catch(function(){
        discBtn.disabled = false;
        discBtn.textContent = 'Anwenden';
        showDiscountMsg('Fehler beim Anwenden', false);
        return false;
      });
  }

  function removeDiscount(){
    return updateDiscountCode('')
      .then(function(){ return new Promise(function(ok){ setTimeout(ok, 300); }); })
      .then(fetchCart)
      .then(function(c){
        cart = c;
        appliedCode = '';
        /* v10: reconcile gift after removing discount — subtotal may now reach 70€ */
        return reconcileGift(c);
      }).then(function(c){
        cart = c;
        render();
      });
  }

  function showDiscountMsg(msg, ok){
    discMsg.innerHTML = '<div class="gl-discount__msg gl-discount__msg--' + (ok ? 'ok' : 'err') + '">' + escHtml(msg) + '</div>';
    setTimeout(function(){ discMsg.innerHTML = ''; }, 4000);
  }

  /* ── Free gift logic — ≥70€ in, <70€ out, never show as paid ── */
  /* v10: skipPriceCheck after qty/delete — changeItem returns stale BXGY data */
  function reconcileGift(c){
    if (isReconciling) return new Promise(function(resolve){ setTimeout(resolve, 200); }).then(function(){ return fetchCart(true); }).then(reconcileGift);
    var retiredGifts = c.items.filter(function(item){ return isGift(item) && GIFT_VARIANTS.indexOf(item.variant_id) === -1; });
    if (retiredGifts.length){
      isReconciling = true;
      scriptAction = true;
      var cleanup = Promise.resolve(c);
      retiredGifts.forEach(function(item){ cleanup = cleanup.then(function(){ return changeItem(item.key, 0); }); });
      return cleanup.finally(function(){ isReconciling = false; scriptAction = false; }).then(function(cleanCart){ return reconcileGift(cleanCart); });
    }

    /* Vergabe deaktiviert: vorhandene Gratisartikel aus dem Warenkorb entfernen,
       danach nichts weiter tun. */
    if (!GIFT_VARIANTS.length){
      var oldGifts = c.items.filter(isGift);
      if (oldGifts.length){
        scriptAction = true;
        isReconciling = true;
        var pg = Promise.resolve(c);
        for (var gi2 = 0; gi2 < oldGifts.length; gi2++){
          (function(key){ pg = pg.then(function(){ return changeItem(key, 0); }); })(oldGifts[gi2].key);
        }
        return pg.finally(function(){ isReconciling = false; scriptAction = false; });
      }
      return Promise.resolve(c);
    }

    var gifts = c.items.filter(isGift);
    var sub = subtotalWithoutGifts(c);

    /* Reset giftBlocked when non-gift items change (add/remove/qty) */
    var nonGiftCount = 0;
    for (var ng = 0; ng < c.items.length; ng++){
      if (!isGift(c.items[ng])) nonGiftCount += c.items[ng].quantity;
    }
    if (nonGiftCount !== lastNonGiftCount){
      giftBlocked = false;
      lastNonGiftCount = nonGiftCount;
    }

    /* Below threshold → remove all gifts */
    if (sub < FREE_GIFT_THRESHOLD){
      giftBlocked = false;
      if (gifts.length > 0){
        scriptAction = true;
        isReconciling = true;
        /* v9: chain sequentially, last changeItem returns the final cart */
        var p = Promise.resolve(c);
        for (var ri = 0; ri < gifts.length; ri++){
          (function(key){ p = p.then(function(){ return changeItem(key, 0); }); })(gifts[ri].key);
        }
        return p.finally(function(){ isReconciling = false; scriptAction = false; });
      }
      return Promise.resolve(c);
    }

    /* Above threshold, gift present but NOT free → remove immediately
       v10: skip after qty/delete — changeItem response has stale BXGY pricing */
    if (gifts.length > 0 && gifts[0].final_line_price > 0){
      giftBlocked = true;
      scriptAction = true;
      isReconciling = true;
      var p2 = Promise.resolve(c);
      for (var ri2 = 0; ri2 < gifts.length; ri2++){
        (function(key){ p2 = p2.then(function(){ return changeItem(key, 0); }); })(gifts[ri2].key);
      }
      return p2.finally(function(){ isReconciling = false; scriptAction = false; });
    }

    /* Above threshold, no gift, not blocked → add one, then verify it's free */
    if (gifts.length === 0 && !giftBlocked){
      isReconciling = true;
      scriptAction = true;
      var pick = GIFT_VARIANTS[Math.floor(Math.random() * GIFT_VARIANTS.length)];
      return addItem(pick, 1, {_gl_free_gift: '1'})
        .then(function(){ return fetchCart(true); }) /* v9: force fresh fetch to see BXGY price */
        .then(function(newCart){
          var newGifts = newCart.items.filter(isGift);
          if (newGifts.length > 0 && newGifts[0].final_line_price > 0){
            giftBlocked = true;
            return changeItem(newGifts[0].key, 0);
          }
          return newCart;
        })
        .finally(function(){ isReconciling = false; scriptAction = false; });
    }

    if (gifts.length && gifts[0].quantity > 1){
      scriptAction = true;
      isReconciling = true;
      return changeItem(gifts[0].key, 1).finally(function(){ isReconciling = false; scriptAction = false; }).then(reconcileGift);
    }

    /* Above threshold, duplicates → keep only first */
    if (gifts.length > 1){
      scriptAction = true;
      isReconciling = true;
      var p3 = Promise.resolve(c);
      for (var ri3 = 1; ri3 < gifts.length; ri3++){
        (function(key){ p3 = p3.then(function(){ return changeItem(key, 0); }); })(gifts[ri3].key);
      }
      return p3.finally(function(){ isReconciling = false; scriptAction = false; });
    }

    return Promise.resolve(c);
  }

  /* ── Render ── */
  function render(){
    if (!cart) return;

    var items = cart.items;
    var count = itemCount(cart);
    var sub = subtotalWithoutGifts(cart);

    /* Update header count */
    countEl.textContent = count;
    updateHeaderBadge(count);

    /* Empty state */
    if (items.length === 0){
      foot.style.display = 'none';
      content.innerHTML =
        '<div class="gl-empty">' +
          '<div class="gl-empty__icon">🛒</div>' +
          '<div class="gl-empty__text">Dein Warenkorb ist leer</div>' +
          '<button class="gl-empty__cta" onclick="document.getElementById(\'glCartClose\').click()">Weiter shoppen</button>' +
        '</div>';
      return;
    }

    foot.style.display = '';
    var html = '';

    /* Free shipping progress */
    var shipPct = Math.min(100, Math.round(cart.total_price / FREE_SHIP_THRESHOLD * 100));
    var shipRemaining = Math.max(0, FREE_SHIP_THRESHOLD - cart.total_price);
    if (cart.total_price >= FREE_SHIP_THRESHOLD){
      html += '<div class="gl-ship gl-ship--done"><div class="gl-ship__icon">🚚</div><div class="gl-ship__text"><strong>Kostenloser Versand</strong> für deine Bestellung!</div></div>';
    } else if (cart.total_price > 0){
      html += '<div class="gl-ship"><div class="gl-ship__icon">🚚</div><div class="gl-ship__text">Noch <strong>' + fmt(shipRemaining) + '</strong> bis <strong>kostenloser Versand</strong></div><div class="gl-ship__bar"><div class="gl-ship__fill" style="width:' + shipPct + '%"></div></div></div>';
    }

    /* Free gift progress — native Glashes drawer */
    var giftPct = Math.min(100, Math.floor(sub / FREE_GIFT_THRESHOLD * 100));
    var giftRemaining = Math.max(0, FREE_GIFT_THRESHOLD - sub);
    var hasGift = items.some(function(item){ return Number(item.variant_id) === 53831680721232 && item.final_line_price === 0; });
    if (sub > 0){
      var giftReached = sub >= FREE_GIFT_THRESHOLD;
      html += '<div class="gl-gift-banner' + (giftReached ? ' gl-gift-banner--reached' : '') + '" aria-live="polite">';
      html += '<img src="https://cdn.shopify.com/s/files/1/0883/6389/3072/files/glashes-antihaft-leo-pinzette.png?v=1789628625" alt="Leo-Pinzette" width="48" height="56" style="object-fit:contain;background:#fff;border-radius:8px;flex-shrink:0" loading="lazy">';
      html += '<div style="flex:1;min-width:0"><div style="font-size:10px;letter-spacing:1px;text-transform:uppercase;margin-bottom:3px;color:var(--gl-green-dark)">Ein Geschenk für dich</div>';
      html += giftReached ? (hasGift ? '<div><strong>Deine Leo-Pinzette ist gratis dabei</strong> ✓</div>' : '<div><strong>Geschenk-Mindestwert erreicht</strong></div>') : '<div>Noch <strong>' + fmt(giftRemaining) + '</strong> bis zu deiner<br><strong>gratis Leo-Pinzette</strong></div>';
      html += '<div class="gl-gift-banner__bar" role="progressbar" aria-label="Fortschritt zum Gratisgeschenk" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + giftPct + '" style="height:6px;margin-top:9px"><div class="gl-gift-banner__fill" style="width:' + giftPct + '%"></div></div>';
      html += '<div style="font-size:10px;font-weight:400;color:var(--gl-text-light);margin-top:5px">Ab ' + fmt(FREE_GIFT_THRESHOLD) + ' Warenwert nach allen Rabatten · ohne Versand</div></div></div>';
    }

    /* Cart items */
    html += '<div class="gl-items">';
    for (var i = 0; i < items.length; i++){
      var it = items[i];
      var gift = isGift(it);
      var hasDiscount = it.original_line_price > it.final_line_price;
      var imgUrl = it.image ? it.image.replace(/(\.\.+)(\?|$)/, '_160x$1$2') : '';

      html += '<div class="gl-item' + (gift ? ' gl-item--gift' : '') + '" data-key="' + it.key + '">';

      /* Delete button */
      html += '<button class="gl-item__del" data-key="' + it.key + '" aria-label="Entfernen">✕</button>';

      /* Image */
      html += '<div class="gl-item__img">';
      if (imgUrl) html += '<img src="' + imgUrl + '" alt="' + escHtml(it.title) + '" loading="lazy">';
      html += '</div>';

      /* Info */
      html += '<div class="gl-item__info">';
      html += '<div class="gl-item__name">' + escHtml(it.product_title) + '</div>';

      /* Variant title (skip "Default Title") */
      if (it.variant_title && it.variant_title !== 'Default Title'){
        html += '<div class="gl-item__variant">' + escHtml(it.variant_title) + '</div>';
      }

      /* Line item properties (skip internal ones starting with _) */
      var propHtml = '';
      if (it.properties){
        for (var key in it.properties){
          if (it.properties.hasOwnProperty(key) && key.charAt(0) !== '_' && it.properties[key]){
            propHtml += '<div>' + escHtml(key) + ': ' + escHtml(it.properties[key]) + '</div>';
          }
        }
      }
      if (propHtml) html += '<div class="gl-item__props">' + propHtml + '</div>';

      /* Gift tag */
      if (gift){
        html += '<div class="gl-item__gift-tag">🎁 GRATIS</div>';
      }

      /* Bottom: qty + price */
      html += '<div class="gl-item__bottom">';

      /* Quantity controls (not for gift items) */
      if (gift){
        html += '<div style="font-size:12px;color:var(--gl-text-light)">1×</div>';
      } else {
        html += '<div class="gl-qty">' +
          '<button class="gl-qty__btn" data-key="' + it.key + '" data-delta="-1">−</button>' +
          '<span class="gl-qty__val">' + it.quantity + '</span>' +
          '<button class="gl-qty__btn" data-key="' + it.key + '" data-delta="1">+</button>' +
          '</div>';
      }

      /* Price */
      html += '<div class="gl-item__price">';
      if (gift && it.final_line_price === 0){
        if (it.original_line_price > 0) html += '<span class="gl-item__price-was">' + fmt(it.original_line_price) + '</span>';
        html += '<span class="gl-item__price-now gl-item__price-free">' + fmt(0) + '</span>';
      } else if (hasDiscount){
        html += '<span class="gl-item__price-was">' + fmt(it.original_line_price) + '</span>';
        html += '<span class="gl-item__price-now">' + fmt(it.final_line_price) + '</span>';
        /* Show volume % badge — check individual allocations for Mengenrabatt (non-code, 5% or 8%) */
        var volBadgePct = 0;
        var itemAllocs = it.line_level_discount_allocations || [];
        for (var da = 0; da < itemAllocs.length; da++){
          var daApp = itemAllocs[da].discount_application;
          if (daApp && daApp.type !== 'discount_code'){
            var daPct = Math.round(itemAllocs[da].amount / it.original_line_price * 100);
            if (daPct === 5 || daPct === 8) volBadgePct = daPct;
          }
        }
        if (volBadgePct > 0){
          html += '<span style="display:block;font-size:11px;color:var(--gl-green-dark);font-weight:600">-' + volBadgePct + '%</span>';
        }
      } else {
        html += '<span class="gl-item__price-now">' + fmt(it.final_line_price) + '</span>';
      }
      html += '</div>';

      html += '</div>'; /* bottom */
      html += '</div>'; /* info */
      html += '</div>'; /* item */
    }
    html += '</div>';

    content.innerHTML = html;

    /* Cart note — load existing note */
    if (cart.note && noteText.value !== cart.note && !noteBox.classList.contains('open')){
      noteText.value = cart.note;
    }
    if (cart.note){
      noteToggle.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg> Nachricht bearbeiten';
    } else {
      noteToggle.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg> Nachricht hinterlassen';
    }

    /* Discount code section — detect from cart API, never pre-fill */
    var activeCode = appliedCode;
    if (!activeCode && cart.discount_codes) {
      for (var dc = 0; dc < cart.discount_codes.length; dc++) {
        if (cart.discount_codes[dc].applicable) {
          activeCode = cart.discount_codes[dc].code;
          break;
        }
      }
    }
    if (activeCode){
      appliedCode = activeCode;
      discForm.style.display = 'none';
      appliedEl.style.display = '';
      appliedEl.innerHTML =
        '<div class="gl-applied-code">' +
          '<div class="gl-applied-code__name">✓ ' + escHtml(activeCode) + '</div>' +
          '<button class="gl-applied-code__remove" id="glRemoveCode" title="Code entfernen">✕</button>' +
        '</div>';
    } else {
      appliedCode = '';
      discForm.style.display = '';
      appliedEl.style.display = 'none';
    }

    /* v8 FIX: Totals — show ONLY discount code amount, exclude automatic discounts (BXGY Kleber) */
    var totalHtml = '';
    var codeDiscount = 0;
    for (var gi = 0; gi < items.length; gi++){
      var allocs = items[gi].line_level_discount_allocations || [];
      for (var ai = 0; ai < allocs.length; ai++){
        if (allocs[ai].discount_application && allocs[ai].discount_application.type === 'discount_code'){
          codeDiscount += allocs[ai].amount;
        }
      }
    }
    /* Fallback: if no line-level code allocations, use cart-level total_allocated_amount */
    if (codeDiscount === 0 && cart.cart_level_discount_applications){
      for (var cli = 0; cli < cart.cart_level_discount_applications.length; cli++){
        var cla = cart.cart_level_discount_applications[cli];
        if (cla.type === 'discount_code' && cla.total_allocated_amount){
          codeDiscount += cla.total_allocated_amount;
        }
      }
    }
    if (codeDiscount > 0){
      totalHtml += '<div class="gl-totals__line gl-totals__line--discount"><span>Rabatt</span><span>− ' + fmt(codeDiscount) + '</span></div>';
    }

    /* v8 FIX: Show discount code names only (not automatic discounts like BXGY) */
    if (cart.cart_level_discount_applications){
      for (var d = 0; d < cart.cart_level_discount_applications.length; d++){
        var da = cart.cart_level_discount_applications[d];
        if (da.type === 'discount_code') {
          totalHtml += '<div class="gl-totals__line gl-totals__line--discount" style="font-size:12px"><span>↳ ' + escHtml(da.title) + '</span><span></span></div>';
        }
      }
    }

    /* Shipping note */
    if (cart.total_price >= FREE_SHIP_THRESHOLD){
      totalHtml += '<div class="gl-totals__line gl-totals__line--shipping"><span>Versand</span><span>Kostenlos</span></div>';
    }

    /* Volume discount — check individual allocations for Mengenrabatt (non-code, 5% or 8%).
       Works alongside discount codes: each discount type has its own allocation. */
    var totalVolDisc = 0;
    for (var vi = 0; vi < items.length; vi++){
      var vit = items[vi];
      var isGiftItem = vit.properties && vit.properties._gl_free_gift;
      if (isGiftItem) continue;
      var vitAllocs = vit.line_level_discount_allocations || [];
      for (var vai = 0; vai < vitAllocs.length; vai++){
        var vaApp = vitAllocs[vai].discount_application;
        if (vaApp && vaApp.type !== 'discount_code'){
          var vaPct = Math.round(vitAllocs[vai].amount / vit.original_line_price * 100);
          if (vaPct === 5 || vaPct === 8){
            totalVolDisc += vitAllocs[vai].amount;
          }
        }
      }
    }
    if (totalVolDisc > 0){
      totalHtml += '<div class="gl-totals__line gl-totals__line--discount"><span>Mengenrabatt</span><span>− ' + fmt(totalVolDisc) + '</span></div>';
    }

    totalHtml += '<div class="gl-totals__line gl-totals__line--total"><span>Total</span><span>' + fmt(cart.total_price) + '</span></div>';
    totalsEl.innerHTML = totalHtml;
  }

  /* ── Header cart badge ── */
  function updateHeaderBadge(count){
    /* Update any existing cart count badge in the header */
    var badges = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count], .header__cart-count');
    for (var i = 0; i < badges.length; i++){
      badges[i].textContent = count;
      badges[i].style.display = count > 0 ? '' : 'none';
    }
    /* Also update Opus badge if still present */
    var opusBadge = document.querySelector('.opus-cart-number');
    if (opusBadge) opusBadge.textContent = count;
  }

  /* ── Open / Close ── */
  function openDrawer(){
    if (isOpen) return;
    isOpen = true;
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    refresh();
  }

  function closeDrawer(){
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── Refresh cart data + reconcile gift + render ── */
  function refresh(){
    fetchCart().then(function(c){
      cart = c;
      return reconcileGift(c);
    }).then(function(c){
      cart = c;
      render();
    }).catch(function(e){
      console.error('[GLCart]', e);
    });
  }

  /* ── Expose for external use (EARLY, before event listeners) ── */
  window.glCartOpen = openDrawer;
  window.glCartClose = closeDrawer;
  window.glCartRefresh = refresh;

  /* ── Intercept "Add to Cart" to open drawer ── */
  function interceptAddToCart(){
    /* Listen for all form submits with action /cart/add */
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      }).then(function(r){ return r.json(); })
        .then(function(){
          openDrawer();
        })
        .catch(function(err){
          console.error('[GLCart] add error', err);
          /* Fallback: submit form normally */
          form.submit();
        });
    });

    /* v9: Intercept external cart changes — debounced, no cascade */
    var _origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
      var promise = _origFetch.apply(this, arguments);
      if (scriptAction) return promise; /* skip our own calls */
      if (/\/cart\/add/.test(url)){
        promise.then(function(){
          clearTimeout(refreshTimer);
          refreshTimer = setTimeout(function(){ refresh(); openDrawer(); }, 300);
        }).catch(function(){});
      } else if (/\/cart\/(change|update|clear)/.test(url)){
        promise.then(function(){
          clearTimeout(refreshTimer);
          refreshTimer = setTimeout(refresh, 300);
        }).catch(function(){});
      }
      return promise;
    };
  }

  /* ── Cart icon click → open drawer ── */
  function bindCartTriggers(){
    /* Common cart icon selectors */
    var selectors = [
      'a[href="/cart"]',
      'a[href*="/cart"]',
      '[data-cart-trigger]',
      '.header__icon--cart',
      '.cart-icon-bubble',
      '.site-header__cart',
      '[data-opus-open-drawer]',
      '.opus-cart-icon'
    ];

    document.addEventListener('click', function(e){
      for (var i = 0; i < selectors.length; i++){
        var match = e.target.closest(selectors[i]);
        if (match){
          /* Don't intercept if it's a link to /cart page explicitly */
          var href = match.getAttribute('href');
          if (href === '/cart' || (href && href.indexOf('/cart') !== -1)){
            e.preventDefault();
            e.stopPropagation();
            openDrawer();
            return;
          }
        }
      }
    }, true);
  }

  /* ── Kill Opus — v9: CSS-only, no MutationObserver/setInterval overhead ── */
  /* The <style> block at top hides Opus with !important rules.
     One-time JS nuke on init for anything already in DOM. */
  function killOpus(){
    var opusSels = ['#opus-drawer-id','.opus-drawer-container','.opus-cart-widget',
      '.opus-cart-icon-container','.opus-free-shipping-bar','#opus-shadow-container'];
    for(var i=0;i<opusSels.length;i++){
      var els=document.querySelectorAll(opusSels[i]);
      for(var j=0;j<els.length;j++){
        els[j].style.setProperty('display','none','important');
        els[j].style.setProperty('pointer-events','none','important');
      }
    }
  }

  /* ── Volume offer widget → inject _gl_volume property into add-to-cart form ── */
  function bindVolumeWidget(){
    document.addEventListener('click', function(e){
      var opt = e.target.closest('.glp__offer-option');
      if (!opt) return;
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var qty = parseInt(opt.getAttribute('data-qty')) || 1;
      var existing = form.querySelector('input[name="properties[_gl_volume]"]');
      if (existing) existing.remove();
      if (qty > 1){
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[_gl_volume]';
        inp.value = '1';
        form.appendChild(inp);
      }
    });
  }

  /* ── Init ── */
  function init(){
    interceptAddToCart();
    bindCartTriggers();
    killOpus();
    bindVolumeWidget();

    /* Initial cart fetch to set badge */
    fetchCart().then(function(c){
      cart = c;
      return reconcileGift(c);
    }).then(function(c){
      cart = c;
      updateHeaderBadge(itemCount(c));
    });

    console.log('%c[GLCart] v14 loaded', 'color:#7c8c6e;font-weight:bold');
  }

  /* ── Event listeners ── */
  try {

  /* Close */
  overlay.addEventListener('click', closeDrawer);
  document.getElementById('glCartClose').addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  /* Quantity +/- and delete — v9: scriptAction reset, debounced */
  content.addEventListener('click', function(e){
    var btn = e.target.closest('[data-delta]');
    if (btn && !isUpdating){
      var key = btn.dataset.key;
      var delta = parseInt(btn.dataset.delta);
      var item = cart.items.find(function(it){ return it.key === key; });
      if (!item) return;
      var newQty = Math.max(0, item.quantity + delta);

      var row = btn.closest('.gl-item');
      if (row) row.classList.add('gl-item--updating');

      scriptAction = true;
      changeItem(key, newQty).then(function(){
        return fetchCart(true);
      }).then(function(c){
        cart = c;
        return reconcileGift(c);
      }).then(function(c){
        cart = c;
        render();
      }).finally(function(){ scriptAction = false; });
      return;
    }

    var del = e.target.closest('.gl-item__del');
    if (del && !isUpdating){
      var row2 = del.closest('.gl-item');
      if (row2) row2.style.opacity = '0';

      scriptAction = true;
      changeItem(del.dataset.key, 0).then(function(){
        return fetchCart(true);
      }).then(function(c){
        cart = c;
        return reconcileGift(c);
      }).then(function(c){
        cart = c;
        render();
      }).finally(function(){ scriptAction = false; });
    }
  });

  /* Remove applied code */
  document.addEventListener('click', function(e){
    if (e.target.id === 'glRemoveCode' || e.target.closest('#glRemoveCode')){
      removeDiscount();
    }
  });

  /* Discount code submit */
  discBtn.addEventListener('click', function(){
    var code = discInput.value.trim();
    if (code) applyDiscount(code);
  });
  discInput.addEventListener('keydown', function(e){
    if (e.key === 'Enter'){
      e.preventDefault();
      var code = discInput.value.trim();
      if (code) applyDiscount(code);
    }
  });

  /* Cart note toggle + auto-save */
  var noteTimer = null;
  noteToggle.addEventListener('click', function(){
    noteBox.classList.toggle('open');
    if (noteBox.classList.contains('open') && cart && cart.note){
      noteText.value = cart.note;
    }
  });
  noteText.addEventListener('input', function(){
    clearTimeout(noteTimer);
    noteSaved.classList.remove('show');
    noteTimer = setTimeout(function(){
      scriptAction = true; /* v9: prevent interceptor loop */
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({note: noteText.value})
      }).then(function(r){ return r.json(); }).then(function(c){
        cart = c;
        noteSaved.classList.add('show');
        setTimeout(function(){ noteSaved.classList.remove('show'); }, 2000);
      }).finally(function(){ scriptAction = false; });
    }, 600);
  });

  } catch(evtErr) {
    console.error('[GLCart] event listener setup error:', evtErr);
  }

  /* Wait for DOM ready */
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    try { init(); } catch(initErr) { console.error('[GLCart] init error:', initErr); }
  }

})();
